import React from 'react';
import './MetricToggle.css';

interface MetricToggleProps {
  availableMetrics: string[];
  selectedMetrics: string[];
  onMetricToggle: (metric: string) => void;
}

const MetricToggle: React.FC<MetricToggleProps> = ({
  availableMetrics,
  selectedMetrics,
  onMetricToggle
}) => {
  const metricColors = {
    'Accessi': 'rgb(102, 126, 234)',
    'Registrazioni': 'rgb(34, 197, 94)',
    'Diete Nuove': 'rgb(239, 68, 68)',
    'Diete Sett': 'rgb(245, 158, 11)',
    'Diete Gior': 'rgb(168, 85, 247)',
    'Conversioni': 'rgb(236, 72, 153)',
    'Alimenti': 'rgb(14, 165, 233)'
  };

  return (
    <div className="metric-toggle-container">
      <h4>Metriche da visualizzare:</h4>
      <div className="metric-toggles">
        {availableMetrics.map((metric) => {
          const isSelected = selectedMetrics.includes(metric);
          const color = metricColors[metric as keyof typeof metricColors] || '#666';
          
          return (
            <label 
              key={metric} 
              className={`metric-toggle ${isSelected ? 'selected' : ''}`}
              style={{
                '--metric-color': color,
                borderColor: isSelected ? color : '#e1e5e9'
              } as React.CSSProperties}
            >
              <input
                type="checkbox"
                checked={isSelected}
                onChange={() => onMetricToggle(metric)}
              />
              <span className="metric-indicator" style={{ backgroundColor: color }}></span>
              <span className="metric-label">{metric}</span>
            </label>
          );
        })}
      </div>
    </div>
  );
};

export default MetricToggle;